import React, { forwardRef, useContext, useEffect } from "react";
import { ActiveEditorContext } from "../../context/ActiveEditorContext";

const CustomToolbar = forwardRef((props, ref) => {
    const { activeEditor } = useContext(ActiveEditorContext);

  // Handle toolbar clicks to prevent selection loss
  useEffect(() => {
    const toolbar = document.querySelector("#global-toolbar");
    
    if (toolbar) {
      const handleToolbarMouseDown = (e) => {
        const isToolbarElement = 
          e.target.closest('button') || 
          e.target.closest('.ql-picker') ||
          e.target.classList.contains('ql-picker-label') ||
          e.target.classList.contains('ql-picker-item');

        if (isToolbarElement && activeEditor?.quillRef?.current) {
          const quill = activeEditor.quillRef.current.getEditor();
          e.preventDefault();
          
          // Ensure editor has focus and selection
          setTimeout(() => {
            let selection = quill.getSelection();
            if (!selection) {
              const length = quill.getLength();
              selection = { index: length > 0 ? length - 1 : 0, length: 0 };
              quill.setSelection(selection);
            }
            quill.focus();
          }, 0);
        }
      };

      toolbar.addEventListener('mousedown', handleToolbarMouseDown);

      return () => {
        toolbar.removeEventListener('mousedown', handleToolbarMouseDown);
      };
    }
  }, [activeEditor]);

  return (
    <div className="sticky top-0 z-10 bg-white border-b border-gray-300 shadow-sm p-2">
    <div ref={ref} id="global-toolbar">
      <span className="ql-formats">
        <select className="ql-header" defaultValue="">
          <option value="1">Heading 1</option>
          <option value="2">Heading 2</option>
          <option value="3">Heading 3</option>
          <option value="4">Heading 4</option>
          <option value="5">Heading 5</option>
          <option value="6">Heading 6</option>
          <option value="">Normal</option>
        </select>
      </span>
      
      <span className="ql-formats">
        <select className="ql-size" defaultValue="16px">
          <option value="12px">12px</option>
          <option value="14px">14px</option>
          <option value="16px">16px</option>
          <option value="18px">18px</option>
          <option value="24px">24px</option>
          <option value="32px">32px</option>
          <option value="48px">48px</option>
        </select>
      </span>

      <span className="ql-formats">
        <button className="ql-bold" title="Bold"></button>
        <button className="ql-italic" title="Italic"></button>
        <button className="ql-underline" title="Underline"></button>
        <button className="ql-strike" title="Strikethrough"></button>
      </span>

      <span className="ql-formats">
        <select className="ql-color" title="Text color"></select>
        <select className="ql-background" title="Highlight"></select>
      </span>

      <span className="ql-formats">
        <select className="ql-align" title="Alignment"></select>
      </span>

      <span className="ql-formats">
        <button className="ql-list" value="ordered" title="Numbered list"></button>
        <button className="ql-list" value="bullet" title="Bullet list"></button>
      </span>

      <span className="ql-formats">
        <button className="ql-link" title="Insert link"></button>
        <button className="ql-image" title="Insert image"></button>
      </span>

      <span className="ql-formats">
        <button className="ql-clean" title="Clear formatting"></button>
      </span>
    </div>
    {/* Show which editor is active */}
      {activeEditor && (
        <div className="text-xs text-gray-500 mt-1 px-1">
          ✏️ Editing: Text Field #{activeEditor.id}
        </div>
      )}
    </div>
  );
});

CustomToolbar.displayName = "CustomToolbar";

export default CustomToolbar;
